"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get extractPrimaryKeyForAudit () {
        return extractPrimaryKeyForAudit;
    },
    get getIdOffsetTable () {
        return getIdOffsetTable;
    },
    get getPrimaryKeySelectColumns () {
        return getPrimaryKeySelectColumns;
    },
    get getPrimaryKeySortColumns () {
        return getPrimaryKeySortColumns;
    },
    get getUpdatedRows () {
        return getUpdatedRows;
    },
    get getUpdatedRowsQb () {
        return getUpdatedRowsQb;
    }
});
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const getIdOffsetTable = ({ baseModelSqlV2, alias = 'id_offset_tbl', limit, offset })=>{
    return baseModelSqlV2.dbDriver(baseModelSqlV2.getTnPath(baseModelSqlV2.model.table_name, alias)).select(getPrimaryKeySelectColumns({
        model: baseModelSqlV2.model,
        sourceTable: alias
    })).orderBy(getPrimaryKeySortColumns({
        model: baseModelSqlV2.model,
        sourceTable: alias
    })).limit(limit).offset(offset);
};
const getUpdatedRowsQb = (param)=>{
    const { baseModelSqlV2, alias = 'id_offset_tbl', destinationColumn } = param;
    return getIdOffsetTable(param).clearSelect().select(_extends({}, getPrimaryKeySelectColumns({
        model: baseModelSqlV2.model,
        sourceTable: alias
    }), {
        [destinationColumn.title]: baseModelSqlV2.dbDriver.raw(`??.??`, [
            alias,
            destinationColumn.column_name
        ])
    }));
};
const getUpdatedRows = async (param)=>{
    const { baseModelSqlV2 } = param;
    const updatedRows = await await baseModelSqlV2.execAndParse(getUpdatedRowsQb(param).toQuery(), null, {
        raw: true
    });
    const result = [];
    for (const row of updatedRows){
        result.push(extractPrimaryKeyForAudit({
            model: baseModelSqlV2.model,
            row
        }));
    }
    return result;
};
const extractPrimaryKeyForAudit = ({ model, row })=>{
    if (model.primaryKeys.length === 1) {
        const rowResult = _extends({}, row);
        rowResult[model.primaryKeys[0].column_name] = undefined;
        return {
            primaryKeys: row[model.primaryKeys[0].column_name],
            row: rowResult
        };
    }
    const result = {};
    const rowResult = _extends({}, row);
    for (const pk of model.primaryKeys){
        result[pk.column_name] = row[pk.column_name];
        rowResult[pk.column_name] = undefined;
    }
    return {
        primaryKeys: result,
        row: rowResult
    };
};
const getPrimaryKeySelectColumns = ({ model, sourceTable })=>{
    return model.primaryKeys.reduce((props, col)=>{
        const prefix = sourceTable ? `${sourceTable}.` : '';
        props[col.column_name] = `${prefix}${col.column_name}`;
        return props;
    }, {});
};
const getPrimaryKeySortColumns = (param)=>Object.keys(getPrimaryKeySelectColumns(param)).map((colName)=>{
        return {
            column: colName,
            order: 'asc'
        };
    });
